<script setup lang="ts">
defineProps<{ product: SingleProduct }>()
</script>

<template>
  <a class="group mx-auto flex aspect-square h-65 flex-col items-center justify-center gap-2 rounded-full bg-(--background) p-12 pb-8 text-center text-white no-underline hover:brightness-90" href="https://www.pendel.no/nettbutikk">
    <strong class="text-lg font-medium">
      Er du på jakt etter tidligere utgaver av
      {{ product.title ?? product.name }}?
    </strong>
    <span>Du finner dem hos Pendel.</span>
    <UIcon
      name="fal:arrow-right-long"
      class="mt-2 size-8 min-h-8 fill-white transition-transform duration-200 group-hover:translate-x-2"
    />
  </a>
</template>
